import { render } from "./ReserveCompleteView.vue?vue&type=template&id=1367a2b6"
import script from "./ReserveCompleteView.vue?vue&type=script&lang=js"
export * from "./ReserveCompleteView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2671924258/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__